export const FETCH_CURRENCY_REQUEST = "FETCH_CURRENCY_REQUEST";
